import React, {
  RefObject,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  getPayerConfigurations,
} from 'views/EMR/Settings/transport';
import {
  PayerEntryConfigDTO,
} from 'dtos';
import {
  PayerEntryConfigTypes,
} from 'dtos/payerEntryConfigTypes';
import {
  PayerEntryConfigSortKey,
} from 'dtos/payerEntryConfigSortKey';
import {
  SortOrder,
} from 'dtos/sortOrder';
import {
  PayerParams,
} from 'views/EMR/Settings/Payers';
import {
  electronicPayerColumns,
  paperPayerColumns,
} from 'views/EMR/Settings/Payers/columns';

type QueryParams = {
  searchQuery: string;
  configType?: PayerEntryConfigTypes;
  sortBy?: PayerEntryConfigSortKey;
  sortOrder?: SortOrder;
};

type Props = {
  tableRef: RefObject<VirtualTableInstance>;
  params: QueryParams;
  type: PayerParams['type'];
  onPayerConfigDialog: (data?: PayerEntryConfigDTO) => void;
};

export default function PayerConfigList({
  tableRef,
  params,
  type,
  onPayerConfigDialog,
}: Props) {
  const columns = type === 'electronic'
    ? electronicPayerColumns
    : paperPayerColumns;

  return (
    <div className="relative flex flex-col flex-1 overflow-y-hidden">
      <div className="h-full w-full">
        <Table<PayerEntryConfigDTO>
          instanceRef={tableRef as RefObject<VirtualTableInstance>}
          getData={getPayerConfigurations}
          defaultPagination={{
            pageSize: 25,
            pageIndex: 0,
          }}
          getRowId={(row) => row?.payerEntryConfigId ?? 0}
          columns={columns}
          emptySlot="No Payer Configurations Found"
          queryParams={params}
          classes={{
            header: 'px-4',
            scrollContainer: 'justify-center items-center',
            outerRow: '!w-[calc(100%-16px)] left-4',
          }}
          onRowClick={(table, row) => {
            onPayerConfigDialog(row?.original);
          }}
        />
      </div>
    </div>
  );
}
